import moment from 'moment'
import React from 'react'
import Pagination from 'react-js-pagination'
import { connect } from 'react-redux'
import Modal from 'react-responsive-modal'
import AdvancedTable from '../../Components/AdvancedTable'
import FailedTransactionActions from '../../Redux/FailedTransactionRedux'

class FailedTransaction extends React.Component {
  constructor (props) {
    super(props)
    this.dateFormat = 'DD MMM YYYY'
    this.state = {
      page: '1',
      modal: null,
      counter: 0,
      detail: {},
      orderid: ''
    }
  }

  componentDidMount = () => {
    let data = { page: this.state.page }
    this.props.get(data)
  }

  _fetch = (page) => {
    let data = { page }
    this.props.get(data)
  }

  _handleResend = (event) => {
    event && event.preventDefault()
    this.props.trigger()
    setTimeout(() => {
      this._fetch(this.state.page)
    }, 250)
  }

  _handleModal = (modal = null) => {
    this.setState({ modal })
  }

  _handleSelect = (item, modal) => {
    this.setState({
      detail: item.data,
      orderid: item.orderid
    })
    this._handleModal(modal)
  }

  _handleChangePage = (page) => {
    this.setState({ page })
    this._fetch(page)
  }

  render () {
    const { failedTransaction } = this.props
    const { data } = failedTransaction
    const { detail, orderid } = this.state
    return (
      <section className='section'>
        <HeaderHelper
          state={failedTransaction}
          title={'Failed Transactions List'}
          _handleResend={(event) => this._handleResend(event)}
        />
        <AdvancedTable
          colSpan={5}
          header={[
            { field: 'Order ID' },
            { field: 'Attempts' },
            { field: 'Status' },
            { field: 'Date' },
            { field: 'View Details' }
          ]}
          body={
            data.data &&
            data.data.length > 0 &&
            data.data.map(item => ([
              { field: item.orderid },
              { field: item.hit_count },
              { field: item.status },
              { field: moment(item.created_at).format(this.dateFormat) },
              {
                field: <button className='btn btn-primary' onClick={() => this._handleSelect(item, 'data')}>
                  <i className='fa fa-eye' /> View
                </button>
              }
            ]))
          }
        />
        {
          (data.meta && data.meta.count > 10) &&
          <PaginationHelper
            meta={data.meta}
            statePage={this.state.page}
            _handleChangePage={this._handleChangePage}
          />
        }
        <Modal center classNames={{ modal: 'modal-large' }} open={this.state.modal === 'data'} onClose={this._handleModal}>
          <DetailHelper
            orderid={orderid}
            detail={detail}
            _handleModal={() => this._handleModal(null)}
          />
        </Modal>
      </section>
    )
  }
}

const HeaderHelper = ({ state, title, _handleResend }) => (
  <header className='title-block'>
    <div className='d-flex justify-content-between'>
      <h1 className='title'>
        { title }
        {
          (state.fetching || state.processing) &&
            <div className='badge badge-info ml-2'>Loading ...</div>
        }
      </h1>
      <button
        className='btn btn-primary ml-auto'
        onClick={_handleResend}
      >
        <i className='fa fa-upload' /> Resend All
      </button>
    </div>
  </header>
)

const DetailHelper = ({ orderid, detail, _handleModal }) => (
  <section className='section' style={{ width: '50vw' }}>
    <header className='title-block'>
      <h1 className='title'>Failed Transaction Detail</h1>
      <small className='form-text text-muted'>Order ID: {orderid}</small>
    </header>
    <table className='table table-hover table-striped table-bordered'>
      <thead>
        <tr>
          <th className='text-center'>Name</th>
          <th className='text-center'>Value</th>
        </tr>
      </thead>
      <tbody>
        {
          detail && Object.keys(detail).map((key, i) => {
            return (
              <tr key={i}>
                <td className='text-center'>{key}</td>
                <td className='text-center'>{detail[key] || 'No Data'}</td>
              </tr>
            )
          })
        }
      </tbody>
    </table>
    <div className='form-group d-flex justify-content-end'>
      <button className='btn btn-primary' onClick={_handleModal}>Close</button>
    </div>
  </section>
)

const PaginationHelper = ({ meta, currentPage, _handleChangePage }) => (
  <section className='text-center'>
    {
      <Pagination
        innerClass='pagination'
        itemClass='page-item'
        linkClass='page-link'
        activePage={meta.page || currentPage}
        itemsCountPerPage={10}
        totalItemsCount={meta.count}
        pageRangeDisplayed={5}
        onChange={_handleChangePage}
      />
    }
  </section>
)

const stateToProps = (state) => ({
  failedTransaction: state.failedTransaction
})

const dispatchToProps = (dispatch) => ({
  get: (data) => dispatch(FailedTransactionActions.getFailedTransactionRequest(data)),
  trigger: () => dispatch(FailedTransactionActions.triggerFailedTransactionRequest())
})

export default connect(stateToProps, dispatchToProps)(FailedTransaction)



// WEBPACK FOOTER //
// ./src/Pages/Misc/FailedTransaction.js